import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ArrowRightIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function HeroSection() {
  return <section className="relative flex items-center justify-center overflow-hidden pt-[48px] pb-[48px] md:pt-[64px] md:pb-[64px] px-5 bg-[#0F2340]" data-id="element-147">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0" data-id="element-148">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#1A3A5C]/40 via-[#0F2340] to-[#0F2340]" data-id="element-149"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto w-full" data-id="element-150">
        <div data-id="element-151">
          <div className="text-center" data-id="element-152">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#C9A84C]/30 bg-[#0F2340]/50 backdrop-blur-sm mb-6" data-id="element-153">
              <BookOpenIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-154" />
              <span className="text-sm md:text-base font-bold tracking-wider uppercase text-[#C9A84C]" data-id="element-155">
                Mesas Epoxi Pro
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="text-title-main font-bold text-white mb-4" data-id="element-156">
              Domina el{' '}
              <span className="text-[#C9A84C]" data-id="element-157">Brillo Espejo Profesional</span>{' '}
              en Mesas de Resina Epóxica en{' '}
              <span className="underline-gold text-[#C9A84C]" data-id="element-158">7 Días</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="text-subtitle text-gray-300 font-normal italic mb-6" data-id="element-159">
              — Aunque Nunca Hayas Tocado la Resina en tu Vida
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.7,
            delay: 0.35
          }} className="flex justify-center mb-6" data-id="element-160">
              <img src="https://cdn.magicpatterns.com/uploads/eJe52iqhuRsMuEBWjZSfx1/Mocap_Master_resina.png" alt="Mesas Epoxi Pro — La Guía Maestra" className="w-full max-w-md rounded-lg shadow-2xl shadow-black/30" fetchPriority="high" width={448} height={448} data-id="element-161" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-6 mt-6" data-id="element-162">
              <div className="flex items-center gap-2 text-sm md:text-base font-medium text-gray-200" data-id="element-163">
                <ShieldCheckIcon className="w-5 h-5 text-[#22C55E]" data-id="element-164" />
                Pago Seguro
              </div>
              <span className="text-gray-600" data-id="element-165">•</span>
              <div className="flex items-center gap-2 text-sm md:text-base font-medium text-gray-200" data-id="element-166">
                <ZapIcon className="w-5 h-5 text-[#C9A84C]" data-id="element-167" />
                Acceso Inmediato
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} className="flex flex-col items-center gap-4" data-id="element-168">
              <a href="https://resinartesanal.store/cart/51954451415353:1" onClick={trackAddToCart} rel="noopener" className="group relative w-full sm:w-auto inline-flex items-center justify-center gap-3 px-[32px] md:px-[56px] py-[18px] md:py-[20px] bg-gradient-to-r from-[#C9A84C] to-[#E5C877] text-[#0F2340] font-bold text-[16px] md:text-[17px] rounded-md overflow-hidden transition-transform hover:-translate-y-[3px] shadow-[0_10px_25px_rgba(201,168,76,0.3)] hover:shadow-[0_15px_35px_rgba(201,168,76,0.4)]" data-id="element-169">
                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-170"></div>
                <span className="relative" data-id="element-171">QUIERO MI GUÍA AHORA</span>
                <ArrowRightIcon className="relative w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-172" />
              </a>
              <p className="text-footnote text-gray-400 font-medium" data-id="element-173">
                Acceso de por vida • Actualizaciones incluidas
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}